// Страница списка: ?cursor=&limit= (по умолчанию 50, не больше 200), ответ { items, nextCursor }.
import { z } from './zod.ts';

export const PAGE_LIMIT_DEFAULT = 50;
export const PAGE_LIMIT_MAX = 200;

/** Параметры страницы из строки запроса. */
export const PageQuerySchema = z.object({
  cursor: z.string().min(1).max(512).optional(),
  limit: z.coerce.number().int().min(1).max(PAGE_LIMIT_MAX).default(PAGE_LIMIT_DEFAULT),
});

export type PageQuery = z.output<typeof PageQuerySchema>;

/** Ответ списка; nextCursor = null — дальше записей нет. */
export function pageSchema<T extends z.ZodType>(item: T) {
  return z.object({
    items: z.array(item),
    nextCursor: z.string().nullable(),
  });
}

export interface Page<T> {
  items: T[];
  nextCursor: string | null;
}

export type SortValue<F extends string> = F | `-${F}`;

/** ?sort=поле|-поле — только из перечисленных полей. */
export function sortSchema<const F extends readonly string[]>(fields: F) {
  const values = fields.flatMap((f) => [f, `-${f}`]) as SortValue<F[number]>[];
  return z.enum(values);
}

export function parseSort<F extends string>(
  value: SortValue<F>,
): { field: F; direction: 'asc' | 'desc' } {
  return value.startsWith('-')
    ? { field: value.slice(1) as F, direction: 'desc' }
    : { field: value as F, direction: 'asc' };
}
